



















































































import Vue from "vue";
import { axios } from "../plugins";
import { mapState } from "vuex";
import Edit from "@/components/PrjQuota/edit.vue";

const typeMap = {
  "count/configmaps": "配置数",
  "count/cronjobs.batch": "定时任务数",
  "count/deployments.apps": "无状态应用数",
  // "count/deployments.extensions": "无状态应用.扩展数",
  "count/jobs.batch": "普通任务数",
  "count/persistentvolumeclaims": "PVC数",
  "count/replicasets.apps": "副本集数",
  // "count/replicationcontrollers": "副本控制器数",
  "count/secrets": "密钥数",
  "count/services": "服务数",
  "count/statefulsets.apps": "有状态应用数",
  "limits.cpu": "CPU资源限制",
  "limits.memory": "内存资源限制",
  "requests.cpu": "CPU资源预留",
  "requests.memory": "内存资源预留"
};

export default Vue.extend({
  name: "PrjQuota",
  components: { Edit },
  data() {
    return {
      typeMap,
      quota: null as any,
      limit: null as any,
      limitData: null as any, // 编辑limit时的内容
      color: [
        { color: "#23b065", percentage: 30 },
        { color: "#f0c000", percentage: 60 },
        { color: "#f14c47", percentage: 90 }
      ]
    };
  },
  computed: {
    ...mapState("LoginInfo", ["project"])
  },
  mounted() {
    this.getQuota();
    this.getLimit();
  },
  methods: {
    edit() {
      (this.$refs.edit as any).show(this.limitData);
    },
    getQuota() {
      axios
        .get(`/policy/project/${this.project.id}/resourceQuotas`)
        .then(res => {
          this.quota = res.data.data.status;
        });
    },
    getLimit() {
      axios.get(`/policy/project/${this.project.id}/limitRanges`).then(res => {
        this.limitData = res.data.data;
        this.limit = res.data.data.items[0]
          ? res.data.data.items[0].spec.limits[0]
          : null;
      });
    },
    getPersent(value: string, sum: string) {
      if (!value || !sum) return 0;
      if (
        !/(m|core|Mi|Gi|Ti)$/.test(value) &&
        !/(m|core|Mi|Gi|Ti)$/.test(sum)
      ) {
        // 纯数字
        const num = parseFloat(value);
        const s = parseFloat(sum);
        if (isNaN(num) || isNaN(s) || s === 0) return 0;
        return num < s ? (num / s) * 100 : 100;
      } else {
        //
        const num = this.getUnitValue(value);
        const s = this.getUnitValue(sum);
        if (isNaN(num) || isNaN(s) || s === 0) return 0;
        return num < s ? (num / s) * 100 : 100;
      }
    },
    getUnitValue(value: string) {
      const unit = ["m", "core", "Ki", "Mi", "Gi", "Ti"].find(u =>
        value.includes(u)
      );
      switch (unit) {
        case "m":
          return parseInt(value);
        case "Mi":
          return parseFloat(value);
        case "Ki":
          return parseFloat(value) / 1024;
        case "Gi":
          return parseFloat(value) * 1024;
        case "Ti":
          return parseFloat(value) * 1024 * 1024;
        case "core":
          return parseInt(value) * 1000;
        default:
          return parseInt(value);
      }
    },
    formatCpu(value: string) {
      if (!value) return "-";
      if (/m$/.test(value)) {
        return value;
      } else {
        return `${value}core`;
      }
    },
    getCpu(value: string, key: string) {
      if (!value) return "-";
      if (key === "limits.cpu" || key === "requests.cpu") {
        if (/m$/.test(value)) {
          return value;
        } else {
          return `${value}core`;
        }
      } else {
        return value;
      }
    }
  }
});
